  <template>
  <v-dialog
    :value="value"
    @input="(v) => $emit('input', v)"
    max-width="898"
    transition="dialog-transition"
    scrollable
    persistent
  >
    <v-card v-if="value" color="neutral700" class="pos-r px-4" elevation="0">
      <v-card-title>
        <v-avatar size="24" @click="close()" class="close_btn cursor-pointer">
          <img :src="require(`@/assets/icons/close.svg`)" />
        </v-avatar>
        <v-stepper
          v-model.number="step"
          alt-labels
          dense
          class="w100p transparent elevation-0"
        >
          <div class="flex-center">
            <v-stepper-header class="w80p elevation-0">
              <v-stepper-step
                :complete="step > 1"
                step="1"
                class="pb-0"
                :editable="hasData || step > 1"
              >
                <span class="text-body-1 font-weight-bold">
                  {{ $t('COMMON.WORD.UPLOAD_FILE') }}
                </span>
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step
                :complete="step > 2"
                step="2"
                class="pb-0"
                :editable="hasData || step > 2"
              >
                <span class="text-body-1 font-weight-bold">
                  {{ $t('ARTWORK.EDIT.WORD.DISPLAY_SETTINGS') }}
                </span>
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="3" class="pb-0" :editable="hasData">
                <span class="text-body-1 font-weight-bold">
                  {{ $t('ARTWORK.EDIT.WORD.ITEM_INFO') }}
                </span>
              </v-stepper-step>
            </v-stepper-header>
          </div>
        </v-stepper>
      </v-card-title>

      <v-card-text ref="STEPPER_CONTENT" class="px-16">
        <v-stepper v-model="step" alt-labels class="transparent elevation-0">
          <v-stepper-items>
            <v-stepper-content step="1">
              <FileUploadArea
                ref="FileUploadArea"
                v-model="holdingFile"
                :step="step"
                :passing-data="workData"
                :type="workType"
                :method="uploadMethod"
                :img="previewURL"
                :URL="videoURL || websiteURL || fileUrl"
                :passed-ipfs-link.sync="ipfsLink"
                :analyzed.sync="isAnalyzed"
                :analyzing.sync="isAnalyzing"
                @update-video-URL="(v) => (videoURL = v)"
                @update-website-URL="(v) => (websiteURL = v)"
                @update-URL="(v) => (previewURL = v)"
                @update-type="(v) => (workType = v)"
                @update-method="(v) => (uploadMethod = v)"
                :rules="[
                  (v) => !!v || $t('ARTWORK.EDIT.COPYWRITING.UPLOAD_YOUR_FILE')
                ]"
                :has-data="hasData"
              ></FileUploadArea>
            </v-stepper-content>

            <v-stepper-content step="2">
              <DisplaySetting
                :previewURL="currentFrameImage"
                :type="workType"
                :method="uploadMethod"
                :display-type="form.displayType"
                @change-image="(v) => (currentFrameImage = v)"
                @update-id="(v) => (form.previewedImageId = v)"
                @pick-display-type="(v) => (form.displayType = v)"
                @change-type="currentFrameImage = null"
              />
            </v-stepper-content>

            <v-stepper-content step="3">
              <div class="text-center">
                <div class="text-h5 font-weight-bold">
                  {{ $t('ARTWORK.EDIT.WORD.ITEM_INFO') }}
                </div>
                <div>
                  {{ $t('ARTWORK.EDIT.COPYWRITING.PLEASE_FILL_ITEM_INFO') }}
                </div>
              </div>

              <SizeBox height="48" />

              <v-form ref="form" @submit.prevent="submit">
                <v-text-field
                  :label="$t('ARTWORK.EDIT.WORD.ARTWORK_NAME')"
                  v-model="form.artworkName"
                  :rules="[$rules.required, (v) => $rules.maxLength(v, 64)]"
                  counter="64"
                  background-color="neutral700"
                  outlined
                  @input="validation('artworkName', 64)"
                ></v-text-field>

                <v-text-field
                  :label="$t('ARTWORK.EDIT.WORD.AUTHOR')"
                  v-model="form.authorName"
                  :rules="[$rules.required, (v) => $rules.maxLength(v, 128)]"
                  counter="128"
                  background-color="neutral700"
                  outlined
                  @input="validation('authorName', 128)"
                ></v-text-field>
                <v-text-field
                  :label="$t('ARTWORK.EDIT.WORD.OWNER')"
                  v-model="form.ownerName"
                  :rules="[$rules.required, (v) => $rules.maxLength(v, 128)]"
                  counter="128"
                  background-color="neutral700"
                  outlined
                  @input="validation('authorName', 128)"
                ></v-text-field>

                <v-text-field
                  :label="$t('ARTWORK.EDIT.WORD.EXTERNAL_LINK')"
                  v-model="form.ctaLink"
                  @input="(v) => !v && (form.ctaText = '')"
                  :rules="[$rules.url]"
                  background-color="neutral700"
                  outlined
                ></v-text-field>

                <v-expand-transition>
                  <v-row v-if="form.ctaLink">
                    <v-col cols="auto">
                      <v-text-field
                        :placeholder="
                          $t('ARTWORK.EDIT.WORD.PLEASE_ENTER_BUTTON_NAME')
                        "
                        v-model="form.ctaText"
                        :rules="[(v) => $rules.maxLength(v, 30)]"
                        counter="30"
                        background-color="neutral700"
                        outlined
                        @input="validation('ctaText', 30)"
                      >
                        <template #append-outer>
                          <v-tooltip right>
                            <template #activator="{ on }">
                              <v-icon v-on="on">mdi-help-circle</v-icon>
                            </template>

                            <div>
                              {{
                                $t(
                                  'ARTWORK.EDIT.COPYWRITING.EXTERNAL_LINKS_APPEAR'
                                )
                              }}
                              <br />
                              {{
                                $t('ARTWORK.EDIT.COPYWRITING.NAME_THE_BUTTON')
                              }}
                            </div>
                            <v-btn color="primary" class="ma-4">
                              {{
                                form.ctaText ||
                                $t('ARTWORK.EDIT.WORD.PLEASE_ENTER_BUTTON_NAME')
                              }}
                            </v-btn>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-expand-transition>

                <p class="mb-2 text-subtitle-1 font-weight-bold">
                  {{ $t('ARTWORK.EDIT.WORD.ITEM_INFO') }}
                </p>
                <VueEditor
                  class="VueEditor"
                  :class="{
                    _error: !!descriptionError,
                    _focus: descriptionFocus
                  }"
                  :placeholder="'請輸入介紹內容...'"
                  v-model="form.artworkDescription"
                  @focus="descriptionFocus = true"
                  @blur="
                    detectDescription();
                    descriptionFocus = false;
                  "
                  @input="detectDescription"
                  useCustomImageHandler
                  @image-added="handleImageAdded"
                ></VueEditor>
                <div class="ml-3 mt-1 error--text">
                  <span
                    :class="{ 'opacity--0': !descriptionError }"
                    class="text-subtitle-2"
                  >
                    {{ descriptionError || 'no-message' }}
                  </span>
                </div>
              </v-form>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>

      <v-card-actions class="mb-6">
        <v-row>
          <v-col cols="12" class="flex-center">
            <v-btn v-if="step <= 1" width="120" outlined @click="close">
              {{ $t('COMMON.WORD.CANCEL') }}
            </v-btn>
            <v-btn v-else width="120" outlined @click="handlePrevStep">
              {{ $t('COMMON.WORD.PREVIOUS') }}
            </v-btn>
            <SizeBox width="16" />
            <v-btn
              v-if="step >= 3"
              width="120"
              color="primary"
              @click="submit"
              :loading="isSubmiting || isUploadingPreview"
            >
              {{ $t('COMMON.WORD.SAVE_CHANGES') }}
            </v-btn>
            <v-btn
              v-else
              width="120"
              color="primary"
              depressed
              @click="handleNextStep"
              :loading="isUploadingPreview || isAnalyzing"
              :disabled="isIpfs && !isAnalyzed"
            >
              {{ $t('COMMON.WORD.NEXT') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { VueEditor } from 'vue2-editor';

import {
  addStaticArtwork,
  addVideoArtwork,
  addMusicArtwork,
  addWebsiteArtwork,
  addModelArtwork
} from '@/api/panel/exhibitions';
import { addImageByCategory } from '@/api/panel/images';
import FileUploadArea from '@/components/exhibitions/_expoId/UploadStepper/FileUploadArea.vue';
import DisplaySetting from './UploadStepper/DisplaySetting.vue';
import { addModel, addMusic } from '@/api/panel/files';

const STEP = {
  UPLOAD: 1,
  FRAME_SET: 2,
  WORK_INFO: 3
};

export default {
  components: { VueEditor, FileUploadArea, DisplaySetting },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    workData: {
      type: Object,
      default: null,
      required: true
    }
  },

  data() {
    return {
      step: 1,
      previewURL: null,
      videoURL: null,
      websiteURL: null,
      holdingFile: null,
      isUploadingPreview: false,
      isSubmiting: false,
      currentFrameImage: null,

      descriptionError: null,
      descriptionFocus: false,

      // sync prop
      workType: '',
      uploadMethod: '',
      fileUrl: '',
      isAnalyzed: false,
      isAnalyzing: false,
      ipfsLink: '',

      formSnapshot: {},
      form: {
        index: null,
        uploadType: '',
        artworkName: '',
        authorName: '',
        ownerName: '',
        ctaLink: '',
        artworkModelUrl: '',
        artworkDescription: '',
        frameType: 'none',
        artworkImageId: null,
        previewedImageId: null,
        ctaText: '',
        displayType: 'model' // model, image
      }
    };
  },

  computed: {
    isIpfs() {
      return this.uploadMethod === 'ipfs';
    },
    hasData() {
      return !!this.workData.data;
    }
  },

  watch: {
    value(v) {
      v ? this.init() : this.reset();
    },
    uploadMethod(v) {
      this.form.uploadType = v;
    },
    holdingFile(v) {
      if (!v) {
        this.previewURL = null;
        this.currentFrameImage = null;
        this.form.previewedImageId = null;
      }
    },
    workType() {
      setTimeout(() => {
        this.$refs.STEPPER_CONTENT &&
          this.$vuetify.goTo(300, {
            container: this.$refs.STEPPER_CONTENT
          });
      }, 80);
    }
  },

  methods: {
    parseType(workData) {
      switch (workData.type) {
        case 'staticArtwork':
          return 'image';
        case 'videoArtwork':
          return 'video';
        case 'musicArtwork':
          return 'sound';
        case 'websiteArtwork':
          return 'website';
        case 'wallVision':
          return 'wallVision';
        case 'modelArtwork':
          return '3dmodel';

        default:
          return '';
      }
    },
    init() {
      const artworkData = this.workData.data;
      this.form.index = this.workData.index;

      if (artworkData) {
        this.currentFrameImage = (artworkData.previewedImage || {}).url;

        this.workType = this.parseType(this.workData);
        this.uploadMethod = artworkData.uploadType;
        artworkData.uploadType === 'ipfs' && (this.isAnalyzed = true);

        // common
        this.form.artworkName = artworkData.artworkName;
        this.form.authorName = artworkData.authorName;
        this.form.ownerName = artworkData.ownerName;
        this.form.ctaLink = artworkData.ctaLink;
        this.form.ctaText = artworkData.ctaText;
        this.form.artworkDescription = artworkData.artworkDescription;
        this.form.previewedImageId = (artworkData.previewedImage || {}).id;

        // image
        const img = artworkData.artworkImage || {};
        this.previewURL = img.url;
        this.form.artworkImageId = img.id;

        // video
        this.videoURL = artworkData.artworkVideoUrl;

        // sound
        this.ipfsLink =
          artworkData.artworkMusicUrl || artworkData.artworkModelUrl;

        // model
        this.form.artworkModelUrl = artworkData.artworkModelUrl;
        this.form.displayType = artworkData.displayType;

        // website
        this.websiteURL = artworkData.artworkWebsiteUrl;

        this.step = STEP.UPLOAD;
      }

      this.$nextTick(() => {
        this.formSnapshot = Object.assign({}, this.form);
      });
    },
    reset() {
      const originData = this.$options.data();
      Object.keys(originData).forEach((key) => {
        this.$set(this.$data, key, originData[key]);
      });
      this.$refs.form.reset();
    },
    close(prompt) {
      let isEdited = false;
      Object.keys(this.form).forEach((key) => {
        if (this.form[key] !== this.formSnapshot[key]) {
          isEdited = true;
        }
      });

      if (prompt || isEdited) {
        this.$store.dispatch('modal/ACTIVE_MODAL', {
          title: this.$t('ARTWORK.EDIT.POPUP.WORD.EXIT_EDITING_MODE'),
          content: this.$t(
            'ARTWORK.EDIT.POPUP.COPYWRITING.EDITS_WILL_NOT_BE_SAVED_CONFIRM_TO_LEAVE'
          ),
          single: true,
          action: {
            text: this.$t('COMMON.WORD.EXIT'),
            color: 'primary',
            callback: () => this.$emit('input', false),
            bind: {
              outlined: true
            }
          },
          cancel: {
            text: this.$t('COMMON.WORD.CANCEL')
          }
        });
        return;
      }
      this.$emit('input', false);
    },
    detectDescription() {
      this.descriptionError = this.form.artworkDescription
        ? null
        : this.$t('ARTWORK.EDIT.INPUT.ALERT.PLEASE_ENTER_ITEM_INFO');
    },
    async submit() {
      let flag = true;

      if (!this.$refs.form.validate()) flag = false;
      this.detectDescription();
      flag = !this.descriptionError;

      if (!flag) return;

      this.isSubmiting = true;

      const isIpfs = this.isIpfs;
      if (this.holdingFile || (isIpfs && this.workType === 'image')) {
        const formData = new FormData();
        formData.append('file', this.holdingFile, this.holdingFile.name);

        let Res = {};

        if (this.workType === 'image') {
          if (isIpfs) {
            formData.append('forceImageUrl', this.ipfsLink);
          }
          const payload = {
            category: 'staticArtworkOriginal',
            data: formData
          };

          Res = await addImageByCategory(payload);
        } else if (this.workType === 'sound') {
          Res = await addMusic(formData);
        } else if (this.workType === '3dmodel') {
          Res = await addModel(formData);
        }

        if (Res.error) {
          this.$toast.error(this.$t('ARTWORK.EDIT.TOAST.ALERT.BUILD_FAIL'));
          this.isSubmiting = false;
          return;
        }

        this.form.artworkImageId = Res.id;
        this.fileUrl = Res.url;
      }

      const APIS = {
        image: addStaticArtwork,
        video: addVideoArtwork,
        sound: addMusicArtwork,
        website: addWebsiteArtwork,
        '3dmodel': addModelArtwork
      };

      const payload = {
        id: this.$route.params.expoId,
        ...this.form
      };

      if (this.workType === 'video')
        payload.artworkVideoUrl = isIpfs ? this.ipfsLink : this.videoURL;
      if (this.workType === 'sound')
        payload.artworkMusicUrl = isIpfs ? this.ipfsLink : this.fileUrl;
      if (!isIpfs && !this.fileUrl) payload.artworkMusicUrl = this.ipfsLink;
      if (this.workType === '3dmodel')
        payload.artworkModelUrl = isIpfs
          ? this.ipfsLink
          : this.fileUrl || this.form.artworkModelUrl;
      if (this.workType === 'website')
        payload.artworkWebsiteUrl = isIpfs ? this.ipfsLink : this.websiteURL;

      console.log(payload);
      const Work = await APIS[this.workType](payload);

      if (!Work.error) {
        this.$emit('save', Work);
        this.$toast(this.$t('ARTWORK.EDIT.TOAST.SUCCESS.BUILD_SUCCESSFUL'));
      } else {
        this.$toast.error(this.$t('ARTWORK.EDIT.TOAST.ALERT.BUILD_FAIL'));
      }

      this.isSubmiting = false;

      this.$emit('input', false);
    },
    handlePrevStep() {
      // make sure step should be number
      this.step = Number(this.step);
      this.step--;
    },
    handleNextStep() {
      // make sure step should be number
      this.step = Number(this.step);
      if (this.step === STEP.UPLOAD) {
        if (this.workType === 'image') {
          if (
            !this.form.artworkImageId &&
            !this.$refs.FileUploadArea.$validate()
          ) {
            return;
          }
          this.drawPreviewImage();
        }

        if (
          this.workType === 'video' ||
          this.workType === 'website' ||
          this.workType === 'sound' ||
          this.workType === '3dmodel'
        ) {
          if (!this.isIpfs && !this.$refs.FileUploadArea.$validate()) return;

          this.step = STEP.FRAME_SET;
        }
      } else if (this.step === STEP.FRAME_SET) {
        if (
          this.workType === 'video' ||
          this.workType === 'website' ||
          this.workType === 'sound'
        ) {
          if (!this.currentFrameImage) {
            this.$toast.error(
              this.$t('ARTWORK.EDIT.TOAST.ALERT.UPLOAD_THUMBNAIL')
            );
            return;
          }
          this.step = STEP.WORK_INFO;
          return;
        }

        if (this.workType === '3dmodel') {
          if (!this.form.displayType) {
            this.$toast.error(
              this.$t('ARTWORK.EDIT.COPYWRITING.SELECT_DISPLAY_METHOD')
            );
            return;
          }
          if (this.form.displayType === 'model') {
            this.step = STEP.WORK_INFO;
            return;
          }
          if (this.form.displayType === 'image') {
            if (!this.currentFrameImage) {
              this.$toast.error(
                this.$t('ARTWORK.EDIT.TOAST.ALERT.UPLOAD_THUMBNAIL')
              );
              return;
            }
            this.step = STEP.WORK_INFO;
            return;
          }
        }

        if (!this.form.previewedImageId || !this.currentFrameImage) {
          this.$toast.error(
            this.$t('ARTWORK.EDIT.TOAST.ALERT.UPLOAD_THUMBNAIL')
          );
          return;
        }

        this.step = STEP.WORK_INFO;
      }
    },
    async uploadPreviewImg(image) {
      const form = new FormData();
      form.append('file', image);
      const { id, url, error } = await addImageByCategory({
        category: 'staticArtworkPreview',
        data: form
      });

      if (!error) {
        // this.$toast('上傳成功');
        this.form.previewedImageId = id;
      } else {
        this.$toast.error(error.message);
      }

      this.isUploadingPreview = false;
    },
    async drawPreviewImage() {
      if (this.form.previewedImageId) {
        this.step = STEP.FRAME_SET;

        return;
      }
      if (!this.holdingFile) return;

      this.isUploadingPreview = true;
      const { file, imgURL } = await this.$shrinkImg(this.previewURL, {
        minWidth: 256,
        minHeight: 256,
        targetSize: 1048576,
        maxWidth: 1024,
        maxHeight: 1024
      });

      this.uploadPreviewImg(file);
      this.currentFrameImage = imgURL;
      this.step = STEP.FRAME_SET;
    },
    async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      if (file.size > 1048576 * 5) {
        this.$toast.error(
          this.$t('ARTWORK.EDIT.TOAST.ALERT.IMAGE_SIZE_CANNOT_EXCEED_5MB')
        );
        resetUploader();
        return;
      }
      const formData = new FormData();
      formData.append('file', file);

      const { url, error } = await addImageByCategory({
        category: 'other',
        data: formData
      });

      if (!error) {
        Editor.insertEmbed(cursorLocation, 'image', url);
        resetUploader();
      } else {
        this.$toast.error(error.message || '圖片上傳失敗');
      }
    },
    async validation(key, limit) {
      if (!this.form[key]) return;
      if (this.form[key].length > limit) {
        await this.$nextTick();
        this.form[key] = this.form[key].slice(0, -1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
html:lang(EN) {
  .v-stepper--alt-labels .v-stepper__step {
    flex-basis: 183px;
  }
}
.close_btn {
  position: absolute;
  top: 8px;
  right: 8px;
}

.VueEditor {
  $bor-rad: 6px;
  :deep(.ql-toolbar) {
    border-radius: $bor-rad $bor-rad 0px 0px !important;
  }
  :deep(.ql-container) {
    border-radius: 0px 0px $bor-rad $bor-rad !important;
  }
  &._focus {
    :deep(.ql-toolbar),
    :deep(.ql-container) {
      border-color: $primary500 !important;
      border-width: 2px;
    }
  }
  &._error {
    :deep(.ql-toolbar),
    :deep(.ql-container) {
      border-color: $error !important;
      border-width: 2px;
    }
  }
}
</style>